import { useEffect } from 'react'

interface RefObject {
  readonly current: any | null
}

export const useOutsideClick = (ref: RefObject, handler?: Function) => {
  useEffect(() => {
    const listener = (event: Event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      // A dialog / sheet layered above (portaled to <body>, role="dialog") belongs to the
      // same interaction: clicking inside it must not dismiss the drawer underneath.
      const target = event.target as Element | null
      if (target && typeof target.closest === 'function' && target.closest('[role="dialog"]')) {
        return
      }

      handler && handler(event)
    }
    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
